var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { defaultListItemMetaProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
var Meta = function (props) {
    if (props === void 0) { props = defaultListItemMetaProps; }
    var avatar = props.avatar, title = props.title, description = props.description, className = props.className, others = __rest(props, ["avatar", "title", "description", "className"]);
    var atomicMeta = ['flex-1', 'items-start'];
    var atomicTitle = ['mb-px-13', 'text-base', 'text-gray-700'];
    var atomicDescription = ['text-sm', 'text-gray-600', 'leading-normal'];
    var atomicAvatar = ['mr-px-16'];
    var content = (React.createElement(DivTag, __assign({ atomics: atomicMeta, className: className }, others),
        title && React.createElement(DivTag, { atomics: atomicTitle }, title),
        description && React.createElement(DivTag, { atomics: atomicDescription }, description)));
    return (React.createElement(React.Fragment, null,
        avatar && React.createElement(DivTag, { atomics: atomicAvatar }, avatar),
        (title || description) && content));
};
var Item = function (props) {
    var extra = props.extra, note = props.note, children = props.children, itemLayout = props.itemLayout;
    var atomicNote = ['mt-px-16'];
    var atomicExtra = ['ml-px-16'];
    var atomicMain = ['flex', 'flex-1'];
    itemLayout == 'vertical' && atomicMain.push('flex-col');
    var renderItem = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(DivTag, { atomics: atomicMain },
                children,
                note && React.createElement(DivTag, { atomics: atomicNote }, note)),
            extra && React.createElement(DivTag, { atomics: atomicExtra }, extra)));
    };
    return React.createElement(React.Fragment, null, renderItem());
};
Item.Meta = Meta;
export { Item };
